<script>
  let { children, title = null } = $props();
</script>

<section class="wf2-section">
  {#if title}<h2 class="wf2-section-title">{title}</h2>{/if}
  {@render children()}
</section>
